import React from 'react';
import { Chip, Tooltip, type ChipProps } from '@mui/material';
import { getRoleLabel, getRoleChipStyle, ROLE_TOOLTIPS } from '../utils/roleUtils';

export interface RoleChipProps {
  role: string;
  size?: ChipProps['size'];
}

const RoleChip: React.FC<RoleChipProps> = ({ role, size = 'small' }) => {
  const style = getRoleChipStyle(role);
  const tooltip = ROLE_TOOLTIPS[role] ?? '';

  const chip = (
    <Chip
      label={getRoleLabel(role)}
      size={size}
      sx={{
        height: 20,
        fontSize: 11,
        fontWeight: 600,
        backgroundColor: style.bg,
        color: style.color,
        border: 'none',
        '& .MuiChip-label': { px: 1 },
      }}
    />
  );

  if (!tooltip) return chip;

  return (
    <Tooltip title={tooltip} placement="top" arrow>
      {chip}
    </Tooltip>
  );
};

export default RoleChip;
